import FullscreenModal from './FullscreenModal';
import {
  ContentProviderAjaxDjangoFetch,
  RESPONSE_JSON_WITH_HTML,
} from '../lib/modals/content_providers/ContentProviderAjax';
import { fsGalleryCarousel } from '../carousels';

class FullscreenGalleryCarouselModal extends FullscreenModal {
  constructor(ajaxUrl) {
    super(
      new ContentProviderAjaxDjangoFetch(
        ajaxUrl,
        { method: 'GET' },
        RESPONSE_JSON_WITH_HTML,
      ),
      {
        display_before_content_load: true,
      },
    );
  }

  initContent() {
    super.initContent();
    this.carousels = fsGalleryCarousel();
  }

  // uninitContent() {
  //   super.uninitContent();
  //   this.carousels.forEach(carousel => carousel.destroy());
  // }
}

export default FullscreenGalleryCarouselModal;



// WEBPACK FOOTER //
// ./src/js/modals/FullscreenGaleryCarouselModal.js